module.exports = __webpack_public_path__ + "static/media/Pașii către o viață echilibrată și de succes.e92196aa.png";